<template>
    <section
        ref="section18"
        :class="[
            Object.keys(validationErrors).length > 0 ? 'has-errors' : '',
            'mx-auto flex h-full flex-col',
        ]"
    >
        <v-add-listing-head :routes="routes" :step="20"></v-add-listing-head>
        <main
            class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
        >
            <figure class="relative flex max-w-3xl flex-col gap-11 lg:w-full">
                <figure class="ml-auto mr-auto flex w-full max-w-lg gap-3">
                    <div><v-icon icon="contract-edit" size="8"></v-icon></div>
                    <div class="flex flex-col justify-center">
                        <div class="mr-6 text-heading-3-desktop">
                            Dodatni podatki
                        </div>
                    </div>
                    <v-lightbox is-authenticated footerless>
                        <template v-slot:trigger>
                            <div
                                class="absolute right-0 top-0 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-white shadow hover:bg-green-25"
                            >
                                <v-icon icon="question-mark" size="4"></v-icon>
                            </div>
                        </template>
                        <template v-slot:head>
                            <div class="flex items-start">
                                <v-icon
                                    icon="question-mark"
                                    class="mr-2.5"
                                    size="4.5"
                                ></v-icon>
                                <div>
                                    Dodatne informacije
                                </div>
                            </div>
                        </template>
                        <template v-slot:content>
                            <p class="mb-[10px] text-icon-text-medium">
                                Spomeniško varstvo
                            </p>
                            <p class="mb-4 text-body-regular">
                                Preverite, če imate potrejeno spomeniško varstvo
                                na vašem objektu. V primeru, da je nepremičnina
                                spomeniško zaščitena, odkljukajte to možnost.
                            </p>
                            <p class="text-body-regular">
                                Objekti pod spomeniškim varstvom so običajno
                                zaradi njihove starosti ali državne ali
                                mednarodne kulturne pomembnosti, zaščiteni.
                                Prenove ali kakršnekoli spremembe na tako
                                imenovanih objektih se mora ob morajo uskladiti
                                s pravnimi organi.
                            </p>
                        </template>
                    </v-lightbox>
                </figure>
                <figure>
                    <form
                        method="POST"
                        :action="routes.submitForm"
                        id="select-extra-data-2"
                    >
                        <v-csrf-token></v-csrf-token>
                        <figure
                            v-if="stepData.showpets"
                            class="mb-4 flex w-full items-center gap-[10px] text-body-medium-button text-black-78 lg:justify-center"
                        >
                            <v-icon icon="pets" size="4"></v-icon>
                            <span>
                                Ali so hišni ljubljenčki dovoljeni? <sup>*</sup>
                            </span>
                        </figure>
                        <figure
                            v-if="stepData.showpets"
                            class="grid grid-cols-1 grid-rows-1 gap-4 lg:flex lg:grid-cols-2 lg:grid-cols-2 lg:flex-wrap lg:justify-center lg:gap-6"
                        >
                            <div
                                name="aliSohisniLjubljenckiDovoljeni-da"
                                :class="[
                                    'tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]',
                                    validationErrors.haustiere
                                        ? 'has-errors'
                                        : '',
                                ]"
                            >
                                <input
                                    type="radio"
                                    name="haustiere"
                                    id="aliSohisniLjubljenckiDovoljeni-da"
                                    value="1"
                                    class="hidden"
                                    v-model="allowsPets"
                                />

                                <label
                                    for="aliSohisniLjubljenckiDovoljeni-da"
                                    class="flex cursor-pointer items-center justify-center gap-[10px] rounded-3xl bg-white p-4 py-6 text-body-medium-button text-black-78 shadow transition-all"
                                >
                                    <v-icon
                                        icon="circle-check"
                                        size="5"
                                    ></v-icon>
                                    <span
                                        class="pointer-events-none select-none"
                                        >Da</span
                                    >
                                </label>
                            </div>
                            <div
                                name="aliSohisniLjubljenckiDovoljeni-ne"
                                :class="[
                                    'tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]',
                                    validationErrors.haustiere
                                        ? 'has-errors'
                                        : '',
                                ]"
                            >
                                <input
                                    type="radio"
                                    name="haustiere"
                                    id="aliSohisniLjubljenckiDovoljeni-ne"
                                    value="0"
                                    class="hidden"
                                    v-model="allowsPets"
                                />

                                <label
                                    for="aliSohisniLjubljenckiDovoljeni-ne"
                                    class="flex cursor-pointer items-center justify-center gap-[10px] rounded-3xl bg-white p-4 py-6 text-body-medium-button text-black-78 shadow transition-all"
                                >
                                    <v-icon icon="cancel" size="5"></v-icon>

                                    <span
                                        class="pointer-events-none select-none"
                                        >Ne</span
                                    >
                                </label>
                            </div>
                            <div
                                name="aliSohisniLjubljenckiDovoljeni-poDogovoru"
                                :class="[
                                    'tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]',
                                    validationErrors.haustiere
                                        ? 'has-errors'
                                        : '',
                                ]"
                            >
                                <input
                                    type="radio"
                                    name="haustiere"
                                    id="aliSohisniLjubljenckiDovoljeni-poDogovoru"
                                    value="2"
                                    class="hidden"
                                    v-model="allowsPets"
                                />

                                <label
                                    for="aliSohisniLjubljenckiDovoljeni-poDogovoru"
                                    class="flex cursor-pointer items-center justify-center gap-[10px] rounded-3xl bg-white p-4 py-6 text-body-medium-button text-black-78 shadow transition-all"
                                >
                                    <v-icon icon="voice" size="5"></v-icon>

                                    <span
                                        class="pointer-events-none select-none"
                                        >Po dogovoru</span
                                    >
                                </label>
                            </div>
                        </figure>
                        <hr v-if="stepData.showpets" class="mb-11 mt-11" />
                        <figure class="ml-auto mr-auto max-w-lg">
                            <ul class="flex flex-col gap-[10px]">
                                <li class="w-full">
                                    <v-checkbox
                                        name="aliNepremicninaSpadaPodSpomeniskoVarstvo"
                                        label="Ali nepremičnina spada pod spomeniško varstvo"
                                        checkbox-position="right"
                                        icon="shield"
                                        @vchanged="isMonument = !isMonument"
                                        :checked="Boolean(isMonumentCasted)"
                                    ></v-checkbox>
                                </li>
                            </ul>
                        </figure>
                        <input
                            type="hidden"
                            name="denkmalgeschuetzt"
                            v-model="isMonumentCasted"
                        />
                    </form>
                </figure>
            </figure>
        </main>
        <v-add-listing-foot>
            <a
                @click="submitForm('select-extra-data-2')"
                :class="[
                    'button button--md h-[48px] w-[240px] px-6',
                    validated ? '' : 'button button--gray',
                ]"
            >
                <label class="text-small-text-medium">Nadaljujte</label>
                <v-icon icon="arrow-right" size="4"></v-icon>
            </a>
        </v-add-listing-foot>
    </section>
</template>
<script>
import AddListingFootVue from "../AddListingFoot.vue";
import AddListingHeadVue from "../AddListingHead.vue";

export default {
    components: {
        "v-add-listing-foot": AddListingFootVue,
        "v-add-listing-head": AddListingHeadVue,
    },
    props: {
        old: {
            type: Object,
            required: false,
            default: {},
        },
        routes: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: true,
            default: {},
        },
        stepData: {
            type: Object,
            required: true,
            default: {},
        },
    },
    data() {
        return {
            isMonument: null,
            allowsPets: null,
        };
    },
    mounted() {
        this.isMonument = this.old.denkmalgeschuetzt
            ? this.old.denkmalgeschuetzt
            : this.stepData.denkmalgeschuetzt;
        this.allowsPets = this.old.haustiere
            ? this.old.haustiere
            : this.stepData.haustiere;
    },
    computed: {
        isMonumentCasted() {
            return this.isMonument ? 1 : 0;
        },
        validated() {
            if (
                this.stepData.vermarktungsart == "miete" &&
                this.stepData.showpets &&
                this.allowsPets == null
            )
                return false;

            return true;
        },
    },
    methods: {
        submitForm(formId) {
            if (this.validated) document.getElementById(formId).submit();
        },
    },
};
</script>
